<template>
<div class="cont" v-bind:style="img_fondo" >
  <div class="demo">
    <div class="login">
        <p class="title" style="font-size: 3rem !important;">POWERSTREET</p>
      <div class="login__form">
        <form
          @submit.prevent="login"
        >        
        <div class="login__row">
          <svg class="login__icon name svg-icon" viewBox="0 0 20 20">
            <path d="M0,20 a10,8 0 0,1 20,0z M10,0 a4,4 0 0,1 0,8 a4,4 0 0,1 0,-8" />
          </svg>
          <input 
            type="text"
            autocomplete="on"
            name="usuario"
            class="login__input name" 
            placeholder="Usuario"
            v-model="usuario"/>
        </div>
        <div class="login__row">
          <svg class="login__icon pass svg-icon" viewBox="0 0 20 20">
            <path d="M0,20 20,20 20,8 0,8z M10,13 10,16z M4,8 a6,8 0 0,1 12,0" />
          </svg>
          <input 
            type="password"
            name="password"
            autocomplete="on"
            class="login__input pass" 
            placeholder="Contraseña"
            v-model="clave"/>
        </div>
        <button 
          ref="envio"
          class="login__submit"
          type="submit"
          :disabled="btn_desactivado"
          >Acceder</button>
          </form>
      </div>
    </div>
  </div>  
   <v-footer padless absolute style="color: white; background-color: rgb(255 255 255 / 0%);">               
    <v-col
      style="float: right;"
        class="text-right"
        cols="12"      
      >                
    <a style="padding-right: 15px;" @click="ver_version()">Versión {{version}}</a> <a target="_blank" style="padding-right: 15px; text-decoration: none;" href="https://www.power-street.com/aviso-privacidad.php">Aviso de privacidad</a>
    </v-col>     
  </v-footer>
  <ModalVersion
        :esActiva="modal_version"
        :version="version"
        @respuesta_modal_cancelar ="(valor) => {modal_version = false;}
      "
    />  
  <ModalAvisoPrivacidad
    :activarModal="modal_aviso_privacidad"
    :ventana="estilo_ventana"    
    @modal_cancelar ="(valor) => {modal_aviso_privacidad = false;}"
  />  
</div>
</template>

<script>
import ModalVersion from "@/components/LoginGeneral/ModalVersion.vue";
import ModalAvisoPrivacidad from "@/components/LoginGeneral/ModalAvisoPrivacidad.vue";
import Conexion_api from "@/api/Conexion_api.js";
import redireccionar from "@/funciones/redireccionar.js";
import Vista from "@/objetos/vista";
import host from '@/objetos/host.js'
const { PROTOCOLO, HOST, PORT } = host

export default {
  name: "LoginGeneral",
  components: {
    ModalVersion,
    ModalAvisoPrivacidad
  },   
    data: () => ({
      vista     : Vista,
      clave     : null,
      usuario   : null,
      img_fondo : {},
      version   : "2-1.0.10",
      modal_version: false,
      modal_aviso_privacidad: false,
      estilo_ventana: 'text-h6'      
    }),    
    computed: {
      btn_desactivado: function () {
        if(this.usuario && this.clave){
            return false;
        }
        return  true;
      }
    },
    created(){
      this.vista.nombre =  "/login_general";
      this.obtener_imagen_fondo()
    },
    methods:{
      login(){
        this.$refs["envio"].classList.add("processing");
        this.$refs["envio"].disabled  = true
        Conexion_api({
          body: {
            usuario: String(this.usuario),
            clave: String(this.clave)
          },
          evento: "login/login_general"
        }).then(respuesta => {
          this.$refs["envio"].classList.remove("processing");
          this.$refs["envio"].disabled = false
          
          if(respuesta.data.error){
           this.$alertify.error(respuesta.data.error)
            return
          }
          else  {
            this.manejo_respsuesta_login(respuesta.data)
            return
          }
        }).catch(err => {
          err = String(err)
          this.$refs["envio"].classList.remove("processing");
          console.error(err)
        })         
      },
      manejo_respsuesta_login(datos){
        this.$cookie.set('pwst', datos.token, { expires: '1h' });   
        redireccionar(datos.usuario.modulos[0])              
      },
      obtener_imagen_fondo(){
      const URL_S3_IMAGENES_LOGIN = `${PROTOCOLO}//${HOST}:${PORT}/base/imagenes_login`;
        let calculo_imagen = Math.floor(Math.random() * 11) + 1;
        const IMAGEN = calculo_imagen < 10 ? "0" + calculo_imagen : calculo_imagen;
        this.img_fondo = {
          backgroundImage: `url(${URL_S3_IMAGENES_LOGIN}/${IMAGEN}.jpg)`
        }
      },
      ver_version(){
        this.modal_version = true;
      },
      ver_aviso(){
        this.modal_aviso_privacidad = true
      }       
    }   
}
</script>
<style scoped>
 *, *:before, *:after {
   box-sizing: border-box;
   margin: 0;
   padding: 0;
}

 @media (max-width: 768px) {
   html, body {
     font-size: 50%;
	}
}
 svg {
   display: inline-block;
   width: 2rem;
   height: 2rem;
   overflow: visible;
}
 .svg-icon {
   cursor: pointer;
}
 .svg-icon path {
   stroke: rgba(255, 255, 255, 0.9);
   fill: none;
   stroke-width: 1;
}
 input, button {
   outline: none;
   border: none;
}
 .cont {
   position: relative;
   height: 100%;
   background-size: cover;
   overflow: auto;
   font-family: 'Open Sans', Helvetica, Arial, sans-serif;
}
 .demo {
   position: absolute;
   top: 50%;
   left: 50%;
   margin-left: -15rem;
   margin-top: -18rem;
   width: 30rem;
   height: 32rem;
   overflow: hidden;
}
 .login {
   position: relative;
   height: 100%;
   background: linear-gradient(to bottom, rgba(146, 135, 187, 0.8) 0%, rgba(0, 0, 0, 0.6) 100%);
   transition: opacity 0.1s, transform 0.3s cubic-bezier(0.17, -0.65, 0.665, 1.25);
   transform: scale(1);
}
 .login.inactive {
   opacity: 0;
   transform: scale(1.1);
}
 
 .login__form {
   position: absolute;
   top: 20%;
   left: 0;
   width: 100%;
   height: 50%;
   padding: 1.5rem 2.5rem;
   text-align: center;
}
 .login__row {
   height: 5rem;
   padding-top: 1rem;
   border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
 .login__icon {
   margin-bottom: -0.4rem;
   margin-right: 0.5rem;
}
 .login__icon.name path {
   stroke-dasharray: 73.5019607544;
   stroke-dashoffset: 73.5019607544;
   animation: animatePath 2s 0.5s forwards;
}
 .login__icon.pass path {
   stroke-dasharray: 92.106628418;
   stroke-dashoffset: 92.106628418;
   animation: animatePath 2s 0.5s forwards;
}
 .login__input {
   display: inline-block;
   width: 22rem;
   height: 100%;
   padding-left: 1.5rem;
   font-size: 1.5rem;
   background: transparent;
   color: #fdfcfd;
}
 .login__submit {
   position: relative;
   width: 100%;
   height: 4rem;
   margin: 5rem 0 2.2rem;
   color: rgba(255, 255, 255, 0.8);
   background: #f36;
   font-size: 1.5rem;
   border-radius: 3rem;
   cursor: pointer;
   overflow: hidden;
   transition: width 0.3s 0.15s, font-size 0.1s 0.15s;
}
 .login__submit:after {
   content: "";
   position: absolute;
   top: 50%;
   left: 50%;
   margin-left: -1.5rem;
   margin-top: -1.5rem;
   width: 3rem;
   height: 3rem;
   border: 2px dotted #fff;
   border-radius: 50%;
   border-left: none;
   border-bottom: none;
   transition: opacity 0.1s 0.4s;
   opacity: 0;
}
 .login__submit.processing {
   width: 4rem;
   cursor:none;
   font-size: 0;
}
 .login__submit.processing:after {
   opacity: 1;
   animation: rotate 0.5s 0.4s infinite linear;
}

 .login__signup {
   font-size: 1.2rem;
   color: #aba8ae;
}
 .login__signup a {
   color: #fff;
   cursor: pointer;
}
::placeholder {
	color: rgb(177, 174, 181);
	opacity: 1; /* Firefox */
  }
.title{
	text-align: center;
	font-size: 5em;
	padding-top: 4.0rem;
	color: white;
	text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);       
	
}
 @keyframes animRipple {
   to {
     transform: scale(3.5);
     opacity: 0;
	}
}
 @keyframes rotate {
   to {
     transform: rotate(360deg);
	}
}
 @keyframes animatePath {
   to {
     stroke-dashoffset: 0;
	}
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: white !important;
}

</style> 